export default function calculPrixUnitaireAuto(
  nbFacesDeclarees,
  surfaceUnitaire,
  prorataTemporis,
  tarifM2Annuel,
) {
  return (nbFacesDeclarees ?? 1)
    * (surfaceUnitaire ?? 1)
    * (prorataTemporis ?? 1)
    * (tarifM2Annuel ?? 1);
}
